import React from "react";
import SignalDivIconGenerator from "../../../helpers/icon.util";
import CreateSignalSvg from "./svg/create-signal-svg";

export const createSignalPin = new SignalDivIconGenerator("create-signal", [60, 60], [30, 60]).generateDivIcon(
    <CreateSignalSvg />,
);
